import React from 'react';
import { connect } from 'react-redux';
import { addNoteToSelectedTicket, temporaryUnlockSensitiveData } from 'actions';
import { getUser, extractSelectedInboxTab } from 'extractFromState';
import { getSelectedOrder } from 'selectors/tools';
import { SPECIALIST_ONLY_HINT } from 'constants/noteTypes';
import { twoBtnPopupCreator, oneBtnPopupCreator } from '../../popups/ConfirmPopup/helper';
import { obfuscateSensitiveData } from '../../../util/formatUtil';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { typesArray } from 'constants/sensitiveDataTypes';
import { Data, DataLock } from './ProtectedData.styles';

const ProtectedData = (props) => {
  const {
    component,
    dataType,
    sensitiveData,
    data,
    selectedInboxTab,
    lockSize,
    isAdmin,
    customerId: subscriptionCustomerId,
  } = props;
  const customerId = get(props, 'selectedOrder.customer.id', subscriptionCustomerId);

  const unlockProtectedData = () => {
    if (isDataUnlocked) {
      return;
    }

    if (!['assigned', 'live_chat'].includes(selectedInboxTab) && !isAdmin) {
      return oneBtnPopupCreator({
        content: {
          main: 'Please take the ticket to access the data.',
          iconPath: '/images/x-green.svg',
        },
        btnConfig: 'CLOSE',
      });
    }

    return twoBtnPopupCreator({
      content: {
        main: `You're about to view customer's personal data. Are you sure?`,
        iconPath: '/images/green-alert-bell.svg',
      },
      btnConfig: {
        dismiss: 'Cancel',
        confirm: 'Confirm',
      },
      onConfirm: () => {
        const noteMessage = `Customer's ${dataType} was viewed from ${component}`;

        props.temporaryUnlockSensitiveData(dataType, component, customerId);
        props.addNoteToSelectedTicket(noteMessage, SPECIALIST_ONLY_HINT);
      },
    });
  };

  const placeholder = <DataLock>{props.noPlaceholder ? '' : props.placeholder || 'Click to unlock'}</DataLock>;
  const isDataUnlocked = get(sensitiveData, `[${customerId}][${component}][${dataType}]`, false);

  return (
    <Data className="fs-block" showData={isDataUnlocked} onClick={unlockProtectedData} lockSize={lockSize}>
      {isDataUnlocked ? (
        data
      ) : (
        <>
          {obfuscateSensitiveData(data, dataType)} {placeholder}
        </>
      )}
      {isDataUnlocked ? null : <img src={'/images/new-designs/lock.svg'} alt="lock" />}
    </Data>
  );
};

const mapStateToProps = (state) => ({
  userData: getUser(state),
  sensitiveData: state.sensitiveData,
  selectedInboxTab: extractSelectedInboxTab(state),
  isAdmin: state.user.isAdmin,
  selectedOrder: getSelectedOrder(state),
});

const mapDispatchToProps = (dispatch) => ({
  addNoteToSelectedTicket: (messageBody, noteType) => dispatch(addNoteToSelectedTicket(messageBody, noteType)),
  temporaryUnlockSensitiveData: (dataType, component, customerId) =>
    dispatch(temporaryUnlockSensitiveData(dataType, component, customerId)),
});

ProtectedData.propTypes = {
  data: PropTypes.string.isRequired,
  dataType: PropTypes.oneOf(typesArray).isRequired,
  component: PropTypes.string.isRequired,
  customerId: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedData);
